import DelinquencySettingLayout from '@/modules/global-settings/delinquency/layout/DelinquencySettingLayout.vue';
import { featureGuard } from '@/router/middlewares/guards';

export default [
  {
    name: 'delinquency-management',
    path: 'delinquency-management',
    redirect: { name: 'control-set-up' },
    meta: {
      requiredPrivileges: ['Delinquency-Pro Settings'],
      app: 'Delinquency-Pro'
    },
    component: DelinquencySettingLayout,
    children: [
      {
        path: 'control-actions-set-up',
        name: 'control-actions-set-up',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/delinquency-control-actions/SetUp.vue'
          )
      },
      {
        path: 'control-actions-general-settings',
        name: 'control-actions-general-settings',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/delinquency-control-actions/GeneralSettings.vue'
          )
      },
      {
        path: 'control-actions-task-assignment',
        name: 'control-actions-task-assignment',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/delinquency-control-actions/TaskAssignment.vue'
          )
      },
      {
        path: 'foreclosure-status-settings',
        name: 'foreclosure-status-settings',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/foreclosure/Status.vue'
          )
      },
      {
        path: 'reassignment-status-settings',
        name: 'reassignment-status-settings',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/ReassignmentStatus.vue'
          )
      },
      {
        path: 'foreclosure-qualification-matrix',
        name: 'foreclosure-qualification-matrix',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/foreclosure/QualificationMatrix.vue'
          )
      },
      {
        path: 'foreclosure-collateral-value-adjustment-factors',
        name: 'foreclosure-collateral-value-adjustment-factors',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/foreclosure/CollateralValueAdjustment.vue'
          )
      },
      {
        path: 'collateral-valuation',
        name: 'collateral-valuation',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/CollateralValuationTriggers.vue'
          )
      },
      {
        path: 'grace-days',
        name: 'grace-days',
        component: () =>
          import('@/modules/global-settings/delinquency/views/GraceDays.vue')
      },
      {
        path: 'charge-off-loans',
        name: 'charge-off-loans',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/ChargeOffLoans.vue'
          )
      },
      {
        path: 'escalation',
        name: 'escalation',
        beforeEnter: featureGuard('loanEscalationManagement'),
        component: () =>
          import('@/modules/global-settings/delinquency/views/Escalation.vue')
      },
      {
        path: 'past-due-days-range',
        name: 'past-due-days-range',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/PastDueDaysRange.vue'
          )
      },
      {
        path: 'field-visit',
        name: 'field-visit',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/FieldVisitTrigger.vue'
          )
      },
      {
        path: 'early-warnings-watchlist',
        name: 'early-warnings-watchlist',
        beforeEnter: featureGuard('earlyWarningModule'),
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/EarlyWarningWatchlist.vue'
          )
      },
      {
        path: 'comparison-options',
        name: 'comparison-options',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/ComparisonOptions.vue'
          )
      },
      {
        path: 'loan-priority',
        name: 'loan-priority',
        beforeEnter: featureGuard('loanPriorityManagement'),
        component: () =>
          import('@/modules/global-settings/delinquency/views/LoanPriority.vue')
      },
      {
        path: 'set-up-external-participants',
        name: 'set-up-external-participants',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/ExternalParticipantsSettings.vue'
          )
      },
      {
        path: 'routing-schedule',
        name: 'routing-schedule',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/RoutingSchedule.vue'
          )
      },
      {
        path: 'manage-delinquency-control-targets',
        name: 'manage-delinquency-control-targets',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/ManageDelinquencyControlTargets.vue'
          ),
      },
      {
        path: 'asset-location-settings',
        name: 'asset-location-settings',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/AssetLocationSettings.vue'
          )
      },
      {
        path: 'report-matrix-settings',
        name: 'report-matrix-settings',
        component: () =>
          import(
            '@/modules/global-settings/delinquency/views/ReportMatrixSettings.vue'
          )
      }
    ]
  }
];
